<script>
import {Carousel, Slide} from "vue-carousel";

import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";


/**
 * Basic-table component
 */
export default {
  page: {
    title: "Basic Tables 123213123 ",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {  },
  data() {
    return {
      data: [],
      
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 25, 50, 100],
      sortBy: "age",
      filter: null,
      sortDesc: false,
      filterOn: [],
      numberOfElement: 1,
      totalRows: 1,
      

    };
  },

  created() {
    

  },

  mounted() {
  },
  methods: {
    function(){
        var modal = document.getElementById('myModal');
        var btnclose = document.getElementById("myBtn");
        var span = document.getElementsByClassName("b-close")[0];
        btnclose.onclick = function() {
            modal.style.display = "block";
        }
  
        // Khi span được click thì đóng Modal
        span.onclick = function() {
            modal.style.display = "none";
        }
    
        // Khi click ngoài Modal thì đóng Modal
        window.onclick = function(event) {
            if (event.target == modal) {
                modal.style.display = "none";
            }
        }
    }
  },

  watch: {
    model: {
      deep: true,
      handler(val) {
      }
    },

    
  }
};
</script>

<template>
  <Layout>
    <div class="my" id="myModal">
        <div class="card">
            <div class="row">
                <form role="form">
                <div class="col-12 mt-3">
                    <div class="row mb-3">
                        <button class="b-close">
                            <i class="mdi mdi-close" style="font-size: 30px; line-height: 0"></i>
                        </button>
                        <div class="col-12 mb-3">
                            <h5 class="text-dark font-weight-bold fs-2">CHATBOT</h5>
                        </div>
                        <div class="col-md-3 col-lg-3">
                            <label class="text-black"> Họ và tên </label>
                            <span
                                class="text-danger"
                            >*</span
                            >
                        </div>
                        <div  class="col-md-9 col-lg-9">
                            <div>
                            <input
                                
                                class="form-control"
                                type="search"
                                placeholder="Nhập họ và tên..."
                                
                            />
                            
                            </div>
                        </div>
                        </div>
                        <!-- Số điện thoại -->
                        <div class="row mb-3">
                        <div class="col-md-3 col-lg-3">
                            <label class="text-black"> Căn cước công dân </label>
                            <span
                                class="text-danger"
                            >*</span
                            >
                        </div>
                        <div class="col-md-9 col-lg-9">
                            <div >
                            <input
                                
                                class="form-control"
                                type="text"
                                placeholder="Nhập căn cước công dân..."
                                
                            />
                            
                            </div>
                        </div>
                        </div>
                        <!-- PAKN về việc -->
                        <div class="row mb-3">
                        <div class="col-md-3 col-lg-3">
                            <label class="text-black">Lĩnh vực</label>
                            <span class="text-danger">*</span>
                        </div>
                        <div class="col-md-9 col-lg-9">
                            <input
                                
                                class="form-control"
                                type="search"
                                placeholder="Nhập tiêu đề góp ý..."
                                
                            />
                            
                        </div>
                        </div>
                        <!-- Nội dung -->
                        <div class="row mb-3">
                        <div class="col-md-3 col-lg-3">
                            <label class="text-black">Nội dung </label>
                            <span class="text-danger">*</span>
                        </div>
                        <div class="col-md-9 col-lg-9">
                                <textarea
                                    
                                    class="form-control"
                                    type="search"
                                    rows="8"
                                    placeholder="Nhập nội dung góp ý..."
                                    
                                ></textarea>
                            
                        </div>

                        </div>
                        
                        <div class="row">
                        <div class="col-3"></div>
                        <div class="col-9">
                            <div class="mb-3 row">
                            <label class="col-md-3 col-form-label"></label>
                            <div class="col-md-9">
                                <b-button
                                    type="submit"
                                    class="cs-btn-primary px-5"
                                    style="width: 200px;margin-right: 15px;border-radius: 20px;"
                                >CHAT
                                </b-button>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                </form>
            </div>
        </div>
    </div>
  </Layout>
</template>

<style>
html{
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.4); 
}

.b-close {
    color: #aaaaaa;
    position: absolute;
    right: 0;
    background-color: #fff;
    border: none;
    font-weight: bold;
    width: 50px;
}
.card{
    position: absolute;
    width: 800px;
    right: 0;
    bottom: 0;
  padding: 20px;
}
.td-stt{
  align-items: center;
}

.card-title{
  font-size: 20px;
  color: #000;
}

.table th{
  background-color: rgb(9, 100, 9);
  color: #fff;
  border: 1px solid #ccc;
}


.page-item.active .page-link {
  background-color: rgb(9, 100, 9) !important;
}

</style>
